import { requestApi } from '../util/network'

export const pickupErrandOrder =
(order_id) =>
  requestApi(
    '/o2o_distributor_errand_order/pickup',
    'POST',
    {
      'order_id': order_id
    },
    'distributor'
  )
export const deliverErrandOrder =
    (order_id) =>
      requestApi(
        '/o2o_distributor_errand_order/deliver',
        'POST',
        {
          'order_id': order_id
        },
        'distributor'
      )
export const receiveErrandOrder =
    (order_id, code) =>
      requestApi(
        '/o2o_distributor_errand_order/receive',
        'POST',
        {
          'order_id': order_id,
          'code': code
        },
        'distributor'
      )
export const getErrandOrderList =
(params, type, other) =>
  requestApi(
    '/o2o_distributor_errand_order/get_list',
    'POST',
    Object.assign(
      {
        'page': params.page,
        'per_page': params.per_page,
        'type': type
      },
      other),
    'distributor'
  )

export const getErrandOrderInfo =
(order_id) =>
  requestApi(
    '/o2o_distributor_errand_order/get_info',
    'POST',
    {
      'order_id': order_id
    },
    'distributor'
  )
